<template>
    <div id="description-mongolia-03">
        <div class="header">
            <div class="arrow-down text-center">
                <img :src="arrowDown" alt="arrowDown" @click="clickScroll">
            </div>
        </div>

        <p id="title-description" class="title-description">
            Did you know<br/>
            <span class="text-color">Mongolia</span> has <br/>
            more than <span class="text-color">500</span> <br/>
            <span class="text-color">bird species</span>?
        </p>

        <div class="description">
            <p>With beautiful untouched nature comes exotic wildlife. In particular, Mongolia is especially known for hundreds of migratory and rare birds. Thus, bird watching has become a popular attraction over the years. Visitors and bird enthusiasts will be able to see all sorts of species of falcons, eagles, owls, ducks, swans, buntings and many others.</p>
            <p>In November 2012, the Saker Falcon was recognized as our national bird. A fascinating creature indeed.</p>
        </div>
        <IG />
        <div class="arrow">
            <div class="text-left">
                <router-link to="/description-mongolia-02">
                    <img :src="arrowLeft" alt="arrowLeft">
                </router-link>
            </div>
            <div class="text-right">
                <router-link to="/description-mongolia-04">
                    <img :src="arrowRight" alt="arrowRight">
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import arrowDown from '../../assets/img/arrow-down.png'
import arrowLeft from '../../assets/img/arrow-left.png'
import arrowRight from '../../assets/img/arrow-right.png'
import IG from '@/components/FirstIG'
import { TweenLite } from "gsap/all"

export default {
    name: 'description-mongolia-03',
    components: {
        IG
    },
    data() {
        return {
            arrowDown: arrowDown,
            arrowLeft : arrowLeft,
            arrowRight : arrowRight
        }
    },
    methods: {
        clickScroll() {
            TweenLite.to(window, .6, {scrollTo:{y:"#title-description", offsetY:60}});
        }
    }
}
</script>

<style lang="scss" scoped>
    #description-mongolia-03 {
        .header {
            height: 370px;
            background-image: url('../../assets/img/bg-description-03.png');
            background-size: cover;
            background-repeat: no-repeat;
            position: relative;

            .arrow-down {
                position: absolute;
                bottom: 17px;
                width: 100%;
            }
        }

        .title-description {
            color: #2C2C2C;
            font-size: 30px;
            font-weight: bold;
            padding:0px 20px;
            margin: 30px 0px;
        }

        .text-color {
            color: #228B5B;
        }

        .description {
            padding:0px 20px;
        }

        .arrow {
            display: flex;
            padding: 60px 0 30px;
            div {
                width: 50%;
            }
        }
    }
</style>


